module.exports = __webpack_public_path__ + "static/media/bancolombia-pe-004-active.1def5d0d.svg";